<template>
  <div>
    <md-button
      class="md-primary md-raised"
      @click="onAddTreatmentClick"
      :disabled="!enableAddTreatmentButton"
      >Add Treatment</md-button
    >
  </div>
</template>

<script>
import { eventBus } from "../../../eventbus";
export default {
  name: "AddTreatmentDialogAction",
  data: function () {
    return {
      enableAddTreatmentButton: false,
    };
  },
  methods: {
    onAddTreatmentClick: function () {
      eventBus.onAddTreatmentClick();
      this.$router.push("/admin/treatment/added");
    },
  },
  created: function () {
    var self = this;

    eventBus.$on("add-treatment-form-validation", function (isValid) {
      self.enableAddTreatmentButton = isValid;
    });
  },
  beforeDestroy: function () {
    //todo
    // eventBus.$off("add-client-form-validation");
  },
};
</script>

<style>
</style>